import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "enable-background": "new 0 0 50 50",
  height: "26px",
  id: "Layer_1",
  version: "1.1",
  viewBox: "0 0 50 50",
  width: "26px",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  fill: "none",
  height: "50",
  width: "50"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  fill: "none",
  stroke: "#ffffff",
  "stroke-miterlimit": "10",
  "stroke-width": "4",
  x1: "9",
  x2: "41",
  y1: "25",
  y2: "25"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  fill: "none",
  stroke: "#ffffff",
  "stroke-miterlimit": "10",
  "stroke-width": "4",
  x1: "25",
  x2: "25",
  y1: "9",
  y2: "41"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}